import {
    FETCH_PARTNER_REQUEST,
    GET_PARTNER,
    PARTNER_ERROR,
    GET_SELECTED_PARTNER,
    STORE_ADDED_CONTACT,
    SAVE_CONTACT,
    GET_ALL_PARTNERS,
    ADD_CONTACT,
    GET_SOME_PARTNERS,
    GET_PARTNER_OFFERINGS,
} from '../ActionTypes';

const initialState = {
    initialContacts: [],
    contacts: [],
    selectedPartner: {},
    offerings: [],
    allPartners: [],
    somePartners: [],
    partner: {},
    loading: true,
    error: '',
};

const partnerReduction = (state = initialState, action) => {
    switch (action.type) {
        case ADD_CONTACT:
            return {
                ...state,
                contacts: action.payload,
            };
        case FETCH_PARTNER_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case GET_PARTNER:
            return {
                ...state,
                partner: action.payload,
                loading: false,
                error: '',
            };
        case GET_ALL_PARTNERS:
            return {
                ...state,
                allPartners: action.payload,
                loading: false,
                error: '',
            };
        case GET_SELECTED_PARTNER:
            return {
                partner: [],
                selectedPartner: action.payload,
                loading: false,
                error: '',
            };
        case PARTNER_ERROR:
            return {
                ...state,
                partner: [],
                loading: false,
                error: action.payload,
            };
        case SAVE_CONTACT:
            return {
                ...state,
                initialContacts: [...state.initialContacts, action.payload],
                loading: false,
                error: action.payload,
            };
        case GET_SOME_PARTNERS:
            return {
                ...state,
                somePartners: action.payload,
                loading: false,
                error: '',
            };
        case STORE_ADDED_CONTACT:
            return Object.assign({}, state, {
                contacts: action.payload,
            });
        case GET_PARTNER_OFFERINGS:
            return {
                ...state,
                offerings: action.payload,
            };
        default:
            return state;
    }
};

export default partnerReduction;
